import {
  INCREMENT,
  DECREMENT,
  CONTROL_LOADING,
  CONTROL_DECLARATION,
  CONTROL_EDIT_BENEFIT,
  SAVE_DATA_FROM_API,
  FORM_IS_VALID_UPDATE,
  PAGE_CLICKED_NEXT_UPDATE,
  GENERATE_FOLDER_NAME,
  SELECT_DOCUMENT,
  RESET_SELECT_DOCUMENT,
  ADD_FILE_TO_LIST,
  REMOVE_FILE_FROM_LIST,
  STORE_DOCUMENT_LIST,
  UPDATE_POLICE_REPORT_MANDATORY,
  EDIT_UPLOAD,
  EDIT_ALL_INVALID_FORM,
  CHECKBOX_STATUS_UPDATE,
  UPDATE_SUBMIT_STATUS,
  UPDATE_UI_DATA,
} from "../actions"

import * as Constants from "../../../common/constants"

// Develop note
// Now the initial state is left in pristine conditions and the resulting state is just a copy of the initial state. Remember two key points for avoiding mutations in Redux:
// --use concat(), slice(), or the spread operator for arrays
// --use Object.assign() or object spread of objects

const initialUiData = {
  claimFormTitle: "Windscreen",
  pageNumber: 1,
  maxPageNumber: 1,
  showLoading: false,
  showDeclaration: false,
  isMasterAccClaim: false,

  // ===== UPLOAD START =====
  proofDocuments: [],
  workshopList: [],
  occupationList: [],
  descOfDamageList: [],
  folderName: null,
  totalFileSize: 0,
  compressedFilesize: 0,
  lockUploadDropdown: false,
  isEditUpload: false,
  claimUploadListModel: [],
  tempSelectedDocument: {
    documentId: 0,
    documentDesc: "Please select your document name",
  },
  // ===== UPLOAD END =====

  checkBoxStatus: {
    isAgree: false,
  },
  submittedResult: {
    claimID: "",
  },
  formIsValid: {
    "Review Policy Information": true,
  },
  editBenefits: {},
  clickedNext: {},
}

const uiDataReducer = (state = initialUiData, action) => {
  const newState = Object.assign({}, state)

  switch (action.type) {
    case INCREMENT:
      switch (newState.pageNumber) {
        case 2:
          if (newState.isEditUpload) {
            newState.isEditUpload = false
            newState.pageNumber = 5
          } else {
            newState.pageNumber += 1
          }
          break
        default:
          newState.pageNumber += 1
      }
      window.scroll(0, 0)
      if (newState.maxPageNumber < newState.pageNumber) {
        newState.maxPageNumber = newState.pageNumber
      }
      return Object.assign({}, state, newState)
    case DECREMENT:
      switch (newState.pageNumber) {
        case 2:
          newState.claimUploadListModel = []
          newState.pageNumber -= 1
          break
        case 5:
          newState.editBenefits = {}
          newState.pageNumber -= 1
          break

        default:
          newState.pageNumber -= 1
      }
      window.scroll(0, 0)
      return Object.assign({}, state, newState)

    case CONTROL_LOADING:
      newState.showLoading
        ? (newState.showLoading = false)
        : (newState.showLoading = true)
      return Object.assign({}, state, newState)

    case CONTROL_DECLARATION:
      newState.showDeclaration
        ? (newState.showDeclaration = false)
        : (newState.showDeclaration = true)
      return Object.assign({}, state, newState)

    case CONTROL_EDIT_BENEFIT:
      newState.editBenefits[action.formName]
        ? (newState.editBenefits[action.formName] = false)
        : (newState.editBenefits[action.formName] = true)
      return Object.assign({}, state, newState)

    case SAVE_DATA_FROM_API:
      newState[action.targetName] = action.apiResultList
      return Object.assign({}, state, newState)

    case FORM_IS_VALID_UPDATE:
      newState.formIsValid[action.formName] = action.status
      return Object.assign({}, state, newState)

    case PAGE_CLICKED_NEXT_UPDATE:
      newState.clickedNext[action.pageClickedNext] = true
      return Object.assign({}, state, newState)

    case GENERATE_FOLDER_NAME:
      let dd = new Date()
      let ss =
        "" +
        dd.getYear() +
        dd.getMonth() +
        dd.getDate() +
        dd.getHours() +
        dd.getMinutes() +
        dd.getSeconds()

      newState.folderName = "Windscreen_" + ss
      return Object.assign({}, state, newState)

    case SELECT_DOCUMENT:
      newState.tempSelectedDocument = {
        documentId: action.documentId,
        documentDesc: action.documentDesc,
      }
      return Object.assign({}, state, newState)

    case RESET_SELECT_DOCUMENT:
      newState.tempSelectedDocument = {
        documentId: 0,
        documentDesc: "Please select your document name",
      }
      return Object.assign({}, state, newState)

    case ADD_FILE_TO_LIST:
      newState.claimUploadListModel.push({
        fileName: action.fileName,
        documentId: action.documentId,
        filePath: action.filePath,
        fileSize: action.fileSize,
        folderName: action.folderName,
        compressedFilesize: action.compressedFilesize,
      })

      newState.totalFileSize += action.compressedFilesize

      return Object.assign({}, state, newState)

    case REMOVE_FILE_FROM_LIST:
      let indexOfUploadedDocumentArray = newState.claimUploadListModel
        .map(function(e) {
          return e.fileName
        })
        .indexOf(action.fileName)
      newState.claimUploadListModel.splice(indexOfUploadedDocumentArray, 1)
      newState.totalFileSize -= action.fileSize
      return Object.assign({}, state, newState)

    case STORE_DOCUMENT_LIST:
      newState.proofDocuments = action.apiResponseData
      return Object.assign({}, state, newState)

    case UPDATE_POLICE_REPORT_MANDATORY:
      let indexOfPoliceReport = newState.proofDocuments
        .map(function(e) {
          return e.documentId
        })
        .indexOf(Constants.policeReportDocumentID)
      newState.proofDocuments[indexOfPoliceReport].mandatory =
        action.updatedValue

      return Object.assign({}, state, newState)

    case EDIT_UPLOAD:
      newState.isEditUpload = true
      newState.pageNumber = 2
      return Object.assign({}, state, newState)

    case EDIT_ALL_INVALID_FORM:
      newState.editBenefits = {}

      action.formlist.forEach((formlistItem, formlistKey) => {
        newState.editBenefits[formlistItem] = true
      })
      return Object.assign({}, state, newState)

    case CHECKBOX_STATUS_UPDATE:
      !newState.checkBoxStatus[action.checkboxName]
        ? (newState.checkBoxStatus[action.checkboxName] = true)
        : (newState.checkBoxStatus[action.checkboxName] = false)
      return Object.assign({}, state, newState)

    case UPDATE_SUBMIT_STATUS:
      newState.submittedResult.claimID = action.claimID
      return Object.assign({}, state, newState)
    case UPDATE_UI_DATA:
      let property = action.property

      return {
        ...state,
        [property]: action.newData,
      }
    default:
      return Object.assign({}, state, newState)
  }
}
export default uiDataReducer
